// @ts-nocheck

// V2
import annule from './BS_Annule.png';
import arbitre_1 from './BS_arbitre_1.png';
import arbitre_2 from './BS_arbitre_2.png';
import arretgoal from './BS_ArretGoal.png';
import astronaute from './BS_Astronaute.png';
import ballon_bombe from './BS_Ballon_Bombe.png';
// V3
import basketteur from './BS_Basketteur.png';
import blessure from './BS_blessure.png';
import bombe from './BS_Bombe.png';
import boucher from './BS_Boucher.png';
import boxeur from './BS_Boxeur.png';
import boxeur_mortal_combo from './BS_BoxeurMortalCombo.png';
import but from './BS_But.png';
import casa_de_papel from './BS_Casa_de_Papel.png';
import catcheur from './BS_Catcheur.png';
import cendrillon from './BS_Cendrillon.png';
import chevaltroie from './BS_ChevalTroie.png';
import chevre from './BS_chevre.png';
import cibles from './BS_Cibles.png';
import cote_killer_astronaute from './BS_Cote_Killer_Astronaute.png';
import cote_killer_casade_papel from './BS_CoteKillerCasadePapel.png';
import dab from './BS_dab.png';
import pierre from './BS_Defaite_Ballon_Pierre.png';
import dernierrempart from './BS_DernierRempart.png';
import duel from './BS_Duel.png';
import echiquier from './BS_Echiquier.png';
import egypte from './BS_Egypte.png';
import entraineur from './BS_Entraineur.png';
import excalibur from './BS_Excalibur.png';
import footus from './BS_Foot_US.png';
import forgeron from './BS_Forgeron.png';
import formule1 from './BS_Formule1.png';
import genie from './BS_Genie.png';
import goalpieuvre from './BS_Goalpieuvre.png';
import golf from './BS_Golf.png';
import halterophile from './BS_Halterophile.png';
import hockey from './BS_Hockey.png';
import indiana from './BS_Indiana.png';
import irma from './BS_irma.png';
import joueuror from './BS_JoueurOr.png';
import lapin from './BS_Lapin_Fou.png';
import lion from './BS_Lion_Cote_Killer.png';
import main_de_dieu from './BS_Main_de_Dieu.png';
import man_of_mymatch from './BS_Man_of_MyMatch.png';
import marabout from './BS_Marabout.png';
import marionnettes from './BS_Marionnettes.png';
import mbappe from './BS_mbappe.png';
import militaire from './BS_Militaire.png';
import mission_impossible from './BS_MissionImpossible.png';
import mortal_1 from './BS_mortal_1.png';
import mortal_2 from './BS_mortal_2.png';
import mortal_combo_genie from './BS_Mortal_Combo_Genie.png';
import mymatch from './BS_MyMatch.png';
import mymatch_en_cours from './BS_MyMatch_en_cours.png';
import mymatch_perdu from './BS_MyMatch_perdu.png';
import mymatch_foot from './BS_MyMaytchFoot.png';
import numero9 from './BS_Numero9.png';
import pinceCashout from './BS_Pince_Cashout.png';
import pinceGold from './BS_Pince_Gold.png';
import pinceLost from './BS_Pince_Lost.png';
import pincePig from './BS_Pince_Pig.png';
import piscine from './BS_Piscine.png';
import poulpe from './BS_Poulpe.png';
import raquette from './BS_Raquette.png';
import renard from './BS_Renard.png';
import sage from './BS_Sage.png';
import singe from './BS_singe.png';
import ski from './BS_Ski.png';
import supersub from './BS_SuperSub.png';
import surfeur from './BS_Surfeur.png';
import systeme_en_cours from './BS_Systeme_en_cours.png';
import systeme_gagnant from './BS_Systeme_gagnant.png';
import systeme_perdant from './BS_Systeme_perdant.png';
import telephone from './BS_Tel_victoire.png';
import tennis from './BS_Tennis.png';
import ultra from './BS_Ultra.png';
import voleur from './BS_Voleur.png';
import zombie from './BS_Zombies.png';
// V4

export default {
  singe,
  chevre,
  irma,
  mortal_1,
  mortal_2,
  arbitre_1,
  arbitre_2,
  dab,
  mbappe,
  blessure,
  ballon_bombe,
  forgeron,
  indiana,
  lapin,
  lion,
  ultra,
  voleur,
  cibles,
  mymatch,
  poulpe,
  sage,
  astronaute,
  duel,
  telephone,
  footus,
  genie,
  pierre,
  zombie,
  pinceCashout,
  pinceLost,
  pincePig,
  pinceGold,
  // V2
  annule,
  bombe,
  casa_de_papel,
  catcheur,
  cote_killer_astronaute,
  echiquier,
  egypte,
  excalibur,
  hockey,
  main_de_dieu,
  man_of_mymatch,
  mortal_combo_genie,
  mymatch_en_cours,
  mymatch_perdu,
  piscine,
  raquette,
  surfeur,
  systeme_en_cours,
  systeme_gagnant,
  systeme_perdant,
  // V3
  basketteur,
  boxeur,
  boxeur_mortal_combo,
  cendrillon,
  cote_killer_casade_papel,
  formule1,
  halterophile,
  militaire,
  mission_impossible,
  mymatch_foot,
  // V4
  arretgoal,
  boucher,
  but,
  chevaltroie,
  dernierrempart,
  entraineur,
  goalpieuvre,
  golf,
  joueuror,
  marabout,
  marionnettes,
  numero9,
  renard,
  ski,
  supersub,
  tennis,
};
